export enum EnumExemptionType {
  LICENSE = '1',
  LICENSE_NEW = '2',
  KNOWLEDGE_UPDATE = '3',
  LICENSETEST = '4',
}
